export default theme => ({
  resizableRow: {
    width: 'calc(100% - 15px)',
    borderBottom: `1px solid ${theme.indigo3}`,
    position: 'absolute',
    zIndex: 1
  }
});
